import statesFilterSlice from './statesFilter-slice';

export const { setStateFilters, resetState, resetStateFiltersState } = statesFilterSlice.actions;

export default statesFilterSlice;
